import { render, staticRenderFns } from "./PrivacyContent.vue?vue&type=template&id=0ee57fec&"
import script from "./PrivacyContent.vue?vue&type=script&lang=js&"
export * from "./PrivacyContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports